async function fetchAddToCart(cartAddApiUrl, calculationId) {
    const response = await fetch(cartAddApiUrl, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            calculationId: calculationId,
        }),
    });

    if (!response.ok) {
        const message = `An error has occurred: ${response.status}`;
        throw new Error(message);
    }

    return response;
}

export { fetchAddToCart };
